import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import '@ui/styles/index.scss';
import './styles/app.scss';
import './i18n/config';
import { App } from './app/App';
import { registerAccessTokenProvider } from './modules/account/accessToken';
import { initAuth } from './modules/account/auth/initAuth';

// Finish any sign-in redirect before the first render, so guards see the final auth state.
await initAuth();

// Once, before the first request – never inside a component.
registerAccessTokenProvider();

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
